import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
export function formatDateTime(dateTimeString) {
    const dateTime = new Date(dateTimeString);
    const options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    };
    return dateTime.toLocaleString('en-US', options).replace(',', ' -');
}
export const convertToLocalTimezone = (date) => {
    if (!date)
        return null;
    const currentTimezone = dayjs.tz.guess();
    const dateInLocal = dayjs(date).tz(currentTimezone);
    if (dateInLocal.isValid()) {
        return dateInLocal.format('YYYY-MM-DDTHH:mm:ss');
    }
    else {
        return null;
    }
};
export function formatDateToDutch(date) {
    if (!date)
        return null;
    const d = new Date(date);
    if (isNaN(d.getTime()))
        return null;
    const formattedDateString = d.toLocaleDateString('nl-NL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
    const [day, month, year] = formattedDateString.split('-').map(Number);
    const formattedDate = new Date(year, month - 1, day);
    return formattedDate;
}
export const formatDMY = (date) => {
    if (date !== null && date !== undefined)
        return dayjs(date).format("DD/MM/YYYY");
    return "";
};
